module.exports = __webpack_public_path__ + "assets/images/openClosedOfficePlan-02.74ecece989d0c300033f969205929450.svg";